import React, { useContext, useEffect, useState } from 'react';

import {
  List,
  ListItem,
  ListItemText,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';

import {
  useHistory,
  useParams,
  withRouter,
} from 'react-router-dom';

import PropTypes from 'prop-types';

// import ProgramsListTechnical from './programsListTechnical';
import Footer from '../../fields/footer';
import Header from '../../fields/header';
import MenuDrawerTechnical from '../../fields/menuDrawerTechnical';
import SpinnerLoading from '../../feedback/spinnerLoading';
import TranslationWarning from '../../modals/translationWarning';

import { getFormVariables } from '../../../utils/comms';

import translations from '../../../languages/i18n';
import { addProgramTranslations }  from '../../../languages/i18n';

import generalStyles from '../../../styles/generalStyles';
import { sectionTitle } from '../../../styles/formElementsStyles';
import programConfigurationStyles from '../../../styles/programConfigurationStyles';

// NOTA: Per poder emprar el react-router-dom i enllaçar pàgines s'ha de convertir el component en una funció i exportar-lo embolicat per withRouter
// En cas de que el component sigui un fill directe de Route no fa falta fer-ho
// Explicat al punt 2.1. Using withRouter de https://dev.to/projectescape/programmatic-navigation-in-react-3p1l

import { SessionContext } from '../../../utils/context';

function ListFormVariablesTechnical({ lang, handleChangeLang }) {
  const sessionContext = useContext(SessionContext);

  const classesProgConfig = programConfigurationStyles();

  const [formVariables, setFormVariables] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showTranslationWarning, setShowTranslationWarning] = useState(false);
  
  const { idProgram, formName } = useParams();

  const history = useHistory();

  useEffect(() => {
    const getFormVariablesFromServer = async () => {
      setShowLoading(true);
      const response = await getFormVariables(idProgram, formName, sessionContext.userToken);
        setShowLoading(false);
      if (response.status === 200) { // Tenim llistat
        try {
          await addProgramTranslations(idProgram, sessionContext.userToken);
        } catch (error) {
          setShowTranslationWarning(true);
        }        
        setFormVariables(response.data.formVariables.variables);
      } else if (response === 400) { // Error amb les dades
        console.log('Error 400');
      } else { // Login KO. Altres errors
        console.log(response);
      }
    };
    getFormVariablesFromServer();
  }, []); // [] Indica que l'useEffect només s'executa una vegada, no a cada render


  const classes = generalStyles();
  const sectionTitleStyle = sectionTitle();

  const handleCloseDialog = () => {
    setShowTranslationWarning(false);
  };

  const showMenuDrawer = (show) => {
    setShowDrawer(show);
  };

  return (
    <div className={classes.content}>
      <SpinnerLoading show={showLoading} />
      <TranslationWarning handleClose={handleCloseDialog} message={translations['_formsTranslationsNotAvailable']} open={showTranslationWarning} title={translations['_alert']} />
      {/* ATENCIÓ: el role ve del servidor amb la primera lletra en majuscula, jo ho necessit tot en minuscula */}
      <Header type={sessionContext.role.toLowerCase()} lang={lang} handleChangeLang={handleChangeLang} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <MenuDrawerTechnical type={sessionContext.role.toLowerCase()} showDrawer={showDrawer} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <div className={classes.body}>
        <Grid container direction='column' spacing={2}>
          {/* ----------------------- Fila 0 ----------------------- */}
          <Grid item xs={12}>
            {/* <BreadCrumb role={sessionContext.role.toLowerCase()} home='listPrograms' lang={lang} /> */}
          </Grid>
          {/* ----------------------- Fila 1 ----------------------- */}
          <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_form']}: {formName}</Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila 2 ----------------------- */}
          <Grid item>
            <Grid container justify='center' spacing={2}>
              <Grid item xs={8}>
                <List component="nav">
                  {
                    formVariables.map((variable)=> (
                      <React.Fragment key={variable.sharedId}>
                        <ListItem>
                          <ListItemText primary={translations['_order']} className={classesProgConfig.variablesText1} />
                          <ListItemText primary={variable.order} className={classesProgConfig.variablesText2} />                          
                        </ListItem>
                        <ListItem alignItems="flex-start">
                          <ListItemText primary={translations['_varIdentifier']} className={classesProgConfig.variablesText1} />
                          <ListItemText primary={variable.sharedId} className={classesProgConfig.variablesText2} primaryTypographyProps={{variant: 'h5'}} />
                        </ListItem>
                        <ListItem alignItems="flex-start">
                          <ListItemText primary={translations['_varICHOM']} className={classesProgConfig.variablesText1} />
                          <ListItemText primary={variable.ichomVar === undefined ? translations['_infoNotAvailable'] : (variable.ichomVar ? translations['_yes'] : translations['_no'])} className={classesProgConfig.variablesText2} />
                        </ListItem>
                        <ListItem alignItems="flex-start">
                          <ListItemText primary={translations['_source']} className={classesProgConfig.variablesText1} />
                          <ListItemText primary={variable.dataSource.toString()} className={classesProgConfig.variablesText2} />                          
                        </ListItem>
                        <ListItem>
                          <ListItemText primary={translations['_dataType']} className={classesProgConfig.variablesText1} />
                          <ListItemText primary={variable.dataType.type || variable.dataType} className={classesProgConfig.variablesText2} />                          
                        </ListItem>
                        <ListItem>
                          <ListItemText
                            primary={translations['_question']}
                            secondary={
                              <React.Fragment>
                                <Typography component='span' variant="body2" color="textPrimary" className={classes.nested}>{translations[`_q${variable.sharedId}`]}</Typography>
                              </React.Fragment>
                              }
                            />                            
                        </ListItem>
                        <ListItem>
                        <ListItemText
                            primary={translations['_explanation']}
                            secondary={
                              <React.Fragment>
                                <Typography component='span' variant="body2" color="textPrimary" className={classes.nested}>{translations[`_${variable.sharedId}`]}</Typography>
                              </React.Fragment>
                              }
                            />  
                        </ListItem>
                        <ListItem>
                          <ListItemText primary={translations['_possibleValues']} />
                        </ListItem>
                          {
                            variable.dataType.values && variable.dataType.values.map((value, index) => (
                              <React.Fragment key={`${variable.sharedId}_${value}_${index}`}>
                                <ListItem >
                                  <ListItemText primary={value} className={classesProgConfig.variablesText1} primaryTypographyProps={{variant: 'h5'}}/>
                                  <ListItemText primary={translations[`_o${variable.sharedId}_${value}`]} className={classesProgConfig.variablesText2}/>
                                </ListItem>
                              </React.Fragment>
                            ))
                          }
                        <Divider />
                      </React.Fragment>
                    ))
                  }
                </List>
              </Grid>
            </Grid>
          </Grid>        
        </Grid>
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(ListFormVariablesTechnical);

// Indica i controla els props que se han de passar al component
ListFormVariablesTechnical.propTypes = {
  handleChangeLang: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};
